import GoogleAuthButton from "./GoogleAuthButton";

function OtherSigninOptions() {
  return (
    <div>
      <div className="text-center  text-gray-500 flex items-center py-4">
        <div className="border-t border-gray-300 w-full h-2"></div>
        <div className="px-4 -mt-2">or</div>
        <div className="border-t border-gray-300 w-full h-2"></div>
      </div>
      <GoogleAuthButton />
    </div>
  );
}

export default OtherSigninOptions;
